import classNames from 'classnames';
import { forwardRef } from 'react';
const hostTitleIsItalicCss = "hkvzreh";
const hostTitleCss = "hniwzkz";
export const HostTitle = forwardRef((props, ref) => {
  const {
    isItalic,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(hostTitleCss, {
    [hostTitleIsItalicCss]: isItalic
  }, props.className)} />;
});

require("./host_title.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./host_title.js");